module.exports = __webpack_public_path__ + "static/pic05.7f8f3b53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pics/pic05.jpg
// module id = 141
// module chunks = 159055269280251 213534597649335